__turbopack_context__.v({
  "accordionContent": "jharTa_accordionContent",
  "arrowDawn": "jharTa_arrowDawn",
  "arrowRight": "jharTa_arrowRight",
  "collapsed": "jharTa_collapsed",
});
